module.exports = __webpack_public_path__ + "img/purchase-success.19af0a10.svg";